import { useContext } from "react"
import { FlowBlockStore } from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/stores/FlowBlockState"

const useFlowBlockStore = () => useContext(FlowBlockStore)

export default useFlowBlockStore
